module.exports = __webpack_public_path__ + "static/media/squared.a14ffdc3.jpg";